import { Button, Divider, Form, Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import Sticky from 'react-sticky-el';
import parse from 'html-react-parser';
import GlobalService from '../../../../services/Global.service';
import moment from 'moment';
import classNames from 'classnames';
import ModalConfirm from '../../../../components/Shared/modal/confirm';
import { useRef } from 'react';

const StepPreview = (props) => {
    const { t } = useTranslation();

    const [previewLang, setPreviewLang] = useState('TH');
    const [value, setValue] = useState();
    const [openConfirm, setOpenConfirm] = useState(false);
    const [logo, setLogo] = useState('');

    const previewData = props?.data;

    useEffect(() => {
        const initialValue = {
            ...previewData,
            personalDataCollection: {
                ...previewData.personalDataCollection,
                dataSourceFromDs:
                    previewData.personalDataCollection?.dataSourceFromCheck?.includes(
                        'dataSourceFromDs'
                    ),
                dataSourceFromOther:
                    previewData.personalDataCollection?.dataSourceFromCheck?.includes(
                        'dataSourceFromOther'
                    ),
            },
        };
        setValue(initialValue);
    }, [previewData]);

    const personalDataCollection = value?.personalDataCollection;
    const disclosurePersonalData = value?.disclosurePersonalData;
    const dataSubjectRightAndSecure = value?.dataSubjectRightAndSecure;
    const marketingAdvertising = value?.marketingAdvertising;
    const privacyPolicy = value?.privacyPolicy;
    const dataController = value?.dataController;
    const dpo = value?.dpo;

    let privacyPolicyNoticeDataSubjectType = [];

    const dsTypeGroup =
        personalDataCollection?.privacyPolicyNoticeDataSubjectType;

    if (dsTypeGroup) {
        const dsTypefilter = props?.dsType.filter((ds) =>
            dsTypeGroup.includes(ds.id)
        );
        privacyPolicyNoticeDataSubjectType = dsTypefilter.map((ds) => {
            return {
                dataSubjectId: ds.id,
                dataSubjectNameTh: ds.nameEn,
                dataSubjectNameEn: ds.nameTh,
            };
        });
    }

    // const appName = props?.applications?.find(
    //     (is) => is.applicationId === personalDataCollection?.applicationId
    // );

    useEffect(() => {
        const getImage = async () => {
            try {
                const { data } = await GlobalService.getImage(
                    personalDataCollection?.companyLogoId
                );
                if (data.resultData?.imageId) {
                    setLogo(
                        `data:image/png;base64,${data.resultData?.imageId}`
                    );
                }
            } catch (error) {
                console.log(error);
            }
        };
        if (personalDataCollection?.companyLogoId) {
            getImage();
        } else {
            setLogo('');
        }
    }, [personalDataCollection?.companyLogoId]);

    const statusSwitch = (isPublished, isPublishedVersion) => {
        return (
            <div className="flex items-center space-x-2 mt-1">
                <div
                    className={classNames(
                        'rounded-full w-max px-3 text-xs font-medium',
                        {
                            'text-[#9A9A9A]': !isPublished,
                            'text-[#4ACE8F]': isPublished,
                        }
                    )}
                    style={
                        isPublished
                            ? {
                                  border: '1px solid #4ACE8F',
                              }
                            : {
                                  border: '1px solid #9A9A9A',
                              }
                    }
                >
                    {isPublished ? 'Published' : 'Draft'} {isPublishedVersion}
                </div>
                <span className="text-[#65707A]">
                    {isPublished &&
                        `${t('Published Date')} : ` +
                            `${previewData?.publishDate || '-'}`}
                </span>
            </div>
        );
    };

    let isChange = false;
    let isPublished = false;
    const version = previewData?.version || '0000.0';
    let isPublishedVersion = version;
    const parts = version?.split('.');

    const numberBehindDecimal = parseInt(parts[1]);
    const numberVersion = parseInt(parts[0]);
    if (parts && parts.length > 0) {
        if (numberVersion > 0) {
            isPublished = true;
            isPublishedVersion = parts[0] + '.0';
            if (numberBehindDecimal > 0) {
                isChange = true;
                isPublishedVersion = parts[0] + '.0';
            }
        }
    }
    const getNextVersion = () => {
        let item = '';
        let version = isPublishedVersion;
        for (let index = 0; index <= 3; index++) {
            if (version?.split('.')[0][index] !== '0') {
                item = version
                    ?.split('.')[0]
                    ?.slice(index, version?.split('.')[0]?.length);
                break;
            }
        }
        item = String(Number(item) + 1);
        switch (item?.length) {
            case 1:
                item = '000'.concat(`${item}.0`);
                break;
            case 2:
                item = '00'.concat(`${item}.0`);
                break;
            case 3:
                item = '0'.concat(`${item}.0`);
                break;
            default:
                item = item.concat(`.0`);
                break;
        }
        return item;
    };
    const ref = useRef();

    return (
        <Form name="preview">
            <Sticky stickyClassName="bg-white p-4 w-full z-50">
                <div className="flex px-4">
                    <div className="flex-1">
                        <div className="text-2xl font-semibold">
                            {t('policy.des8')}
                        </div>
                        {statusSwitch(isPublished, isPublishedVersion)}
                    </div>
                    <div className="flex space-x-4">
                        {isChange && (
                            <div className="text-xs text-right text-[#65707A]">
                                <div className="mb-1">
                                    {`${t('LastUpdate')} : ` +
                                        `${
                                            previewData?.lastUpdate !==
                                            undefined
                                                ? moment(
                                                      previewData?.lastUpdate
                                                  ).format('DD/MM/YYYY HH:mm')
                                                : '-'
                                        }`}
                                </div>
                                <div>{`${t('Version')} : ${version}`}</div>
                                <div className="text-[#F0536F]">
                                    <span className="text-xl align-middle">
                                        &bull;
                                    </span>{' '}
                                    {t('Consent.DataChanged')}
                                </div>
                            </div>
                        )}
                        {((numberVersion === 0 && numberBehindDecimal > 0) ||
                            (numberVersion > 0 &&
                                numberBehindDecimal === 0)) && (
                            <div className="text-xs mt-[9px] text-[#65707A]">
                                <div className="mb-1">
                                    {`${t('LastUpdate')} : ` +
                                        `${
                                            previewData?.lastUpdate
                                                ? moment(
                                                      previewData?.lastUpdate
                                                  ).format('DD/MM/YYYY HH:mm')
                                                : '-'
                                        }`}
                                </div>
                            </div>
                        )}
                        <Button
                            type="default"
                            size="large"
                            loading={props.loadingSaveDraft}
                            onClick={props.saveDraft}
                            className="border-purple text-purple px-6"
                        >
                            {t('Save Draft')}
                        </Button>
                        <Button
                            loading={props.loading_}
                            type="primary"
                            size="large"
                            onClick={() => setOpenConfirm(true)}
                        >
                            {t('Save And Publish')}
                        </Button>
                        <button ref={ref} className="hidden" type="submit" />
                    </div>
                </div>
            </Sticky>

            <div className="px-4">
                <Divider className="mb-1" />
                <div className={`py-4 flex space-x-2 text-tiny`}>
                    <span
                        style={{ borderRight: '1px solid #DBDBDB' }}
                        onClick={() => {
                            setPreviewLang('TH');
                        }}
                        className={`${
                            previewLang === 'TH'
                                ? 'text-[#1890FF] font-semibold'
                                : ''
                        } cursor-pointer hover:opacity-80 pr-2`}
                    >
                        {t('policy.th')}
                    </span>
                    <span
                        onClick={() => {
                            setPreviewLang('EN');
                        }}
                        className={`${
                            previewLang === 'EN'
                                ? 'text-[#1890FF] font-semibold'
                                : ''
                        } cursor-pointer hover:opacity-80`}
                    >
                        {t('policy.en')}
                    </span>
                </div>
                <div className=" space-y-4">
                    <div>
                        <div
                            className="flex px-4 py-1 items-center mb-4"
                            style={{ background: '#F4F6FC' }}
                        >
                            <div className="flex-1 text-purple-PHX font-semibold">
                                {previewLang === 'EN'
                                    ? 'Collection of Personal Data'
                                    : 'การรวบรวมข้อมูลส่วนบุคคล'}
                            </div>
                            <div
                                className="mt-1 hover:opacity-80 cursor-pointer"
                                onClick={() => {
                                    props.goToStep(1);
                                }}
                            >
                                {EditIcon}
                            </div>
                        </div>
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'Name of the privacy notice'
                                    : 'ชื่อประกาศความเป็นส่วนตัว'}
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {previewLang === 'TH'
                                    ? personalDataCollection?.privacyPolicyNoticeNameTh ||
                                      '-'
                                    : personalDataCollection?.privacyPolicyNoticeNameEn ||
                                      '-'}
                            </div>
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'Updated as of	'
                                    : 'ฉบับ ณ วันที่'}
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {personalDataCollection?.effectiveDate
                                    ? moment(
                                          personalDataCollection?.effectiveDate
                                      ).format('DD/MM/YYYY')
                                    : '-'}
                            </div>
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'Organization name (or Owner Name)'
                                    : 'ชื่อองค์กร (หรือชื่อบุคคลเจ้าของ)'}
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {previewLang === 'TH'
                                    ? personalDataCollection?.companyNameTh ||
                                      '-'
                                    : personalDataCollection?.companyNameEn ||
                                      '-'}
                            </div>
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'Company Logo'
                                    : 'โลโก้องค์กร'}
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {logo ? (
                                    // eslint-disable-next-line jsx-a11y/img-redundant-alt
                                    <img
                                        className="w-auto h-16 rounded-lg object-cover"
                                        style={{
                                            border: '1px solid #DBDBDB',
                                        }}
                                        src={logo}
                                        alt="image"
                                    />
                                ) : (
                                    svgNoImage
                                )}
                            </div>
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'What types of data subjects does this policy apply to'
                                    : 'นโยบายนี้ใช้กับเจ้าของข้อมูลประเภทใด'}
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {privacyPolicyNoticeDataSubjectType
                                    ?.map((ds) =>
                                        previewLang === 'TH'
                                            ? ds.dataSubjectNameTh
                                            : ds.dataSubjectNameEn
                                    )
                                    .join(', ')}
                            </div>
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'Sources of personal data'
                                    : 'แหล่งที่มาของข้อมูลส่วนบุคคล'}
                            </div>
                            <div>
                                {previewLang === 'EN'
                                    ? 'The company may receive your personal data from the following channels'
                                    : 'บริษัทอาจได้รับข้อมูลส่วนบุคคลของท่านจากช่องทางดังนี้'}{' '}
                                :
                            </div>
                            {personalDataCollection?.dataSourceFromDs && (
                                <div className="text-[#65707A]">
                                    <div>
                                        <div className="font-semibold text-[#65707A]">
                                            {previewLang === 'EN'
                                                ? 'Received directly from data subject'
                                                : 'การเก็บข้อมูลโดยตรงจากท่าน'}
                                        </div>
                                        {parse(
                                            `${
                                                previewLang === 'TH'
                                                    ? previewData
                                                          ?.personalDataCollection
                                                          ?.dataSourceFromDsTh ||
                                                      '-'
                                                    : previewData
                                                          ?.personalDataCollection
                                                          ?.dataSourceFromDsEn ||
                                                      '-'
                                            }`
                                        )}
                                    </div>
                                </div>
                            )}
                            {personalDataCollection?.dataSourceFromOther && (
                                <div className="text-[#65707A]">
                                    <div>
                                        <div className="font-semibold text-[#65707A]">
                                            {previewLang === 'EN'
                                                ? 'Received from another source'
                                                : 'ข้อมูลจากแหล่งอื่น'}
                                        </div>
                                        {personalDataCollection?.dataSourceFromOtherTh ? (
                                            parse(
                                                `${
                                                    previewLang === 'TH'
                                                        ? previewData
                                                              ?.personalDataCollection
                                                              ?.dataSourceFromOtherTh ||
                                                          '-'
                                                        : previewData
                                                              ?.personalDataCollection
                                                              ?.dataSourceFromOtherEn ||
                                                          '-'
                                                }`
                                            )
                                        ) : (
                                            <p>-</p>
                                        )}
                                    </div>
                                </div>
                            )}
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'Purpose for collecting, using or disclosing'
                                    : ' วัตถุประสงค์การเก็บ รวบรวม ใช้และเปิดเผยของบริษัทคือ'}
                            </div>
                            <div className="text-[#65707A] pb-2">
                                {parse(
                                    `${
                                        previewLang === 'TH'
                                            ? personalDataCollection?.purposeOfDataCollectionTh ||
                                              '-'
                                            : personalDataCollection?.purposeOfDataCollectionEn ||
                                              '-'
                                    }`
                                )}
                            </div>
                        </div>
                    </div>
                    <div>
                        <div
                            className="flex px-4 py-1 items-center mb-4"
                            style={{ background: '#F4F6FC' }}
                        >
                            <div className="flex-1 text-purple-PHX font-semibold">
                                {previewLang === 'EN'
                                    ? 'Disclosure and use of Personal data'
                                    : 'การเปิดเผยและนำไปใช้ข้อมูล'}
                            </div>
                            <div
                                className="mt-1 hover:opacity-80 cursor-pointer"
                                onClick={() => {
                                    props.goToStep(2);
                                }}
                            >
                                {EditIcon}
                            </div>
                        </div>
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'Disclose personal data to others'
                                    : 'การเปิดเผยข้อมูลส่วนบุคคลให้บุคคลอื่น'}
                            </div>
                            <div className="py-2 whitespace-pre-wrap text-[#65707A]">
                                {parse(
                                    `${
                                        previewLang === 'TH'
                                            ? disclosurePersonalData?.discloseToOtherPersonTh ||
                                              '-'
                                            : disclosurePersonalData?.discloseToOtherPersonEn ||
                                              '-'
                                    }`
                                )}
                            </div>
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'Personal Data Collected'
                                    : 'ข้อมูลส่วนบุคคล	'}
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {disclosurePersonalData
                                    ?.personalDataOptionSequence?.length ===
                                    0 && '-'}
                                {disclosurePersonalData?.personalDataOptionSequence?.map(
                                    (item, i) => (
                                        <div
                                            key={i}
                                            className="flex space-x-2 pl-2"
                                        >
                                            <div className="w-1 -mt-[2px]">
                                                {Dot}
                                            </div>
                                            <div>
                                                {item.personDataOptionNameTh}
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'Sensitive personal data'
                                    : 'ข้อมูลส่วนบุคคลอ่อนไหว'}
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {disclosurePersonalData
                                    ?.sensitivePersonalDataOptionSequence
                                    ?.length === 0 && '-'}
                                {disclosurePersonalData?.sensitivePersonalDataOptionSequence?.map(
                                    (item, i) => (
                                        <div
                                            key={i}
                                            className="flex space-x-2 pl-2"
                                        >
                                            <div className="w-1 -mt-[2px]">
                                                {Dot}
                                            </div>
                                            <div>
                                                {
                                                    item.sensitivePersonDataOptionNameTh
                                                }
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'Period of personal data storage'
                                    : 'ระยะเวลาในการเก็บรักษาข้อมูลส่วนบุคคล'}
                            </div>
                            <div className="py-2 whitespace-pre-wrap text-[#65707A]">
                                {parse(
                                    `${
                                        previewLang === 'TH'
                                            ? disclosurePersonalData?.retentionPeriodTh ||
                                              '-'
                                            : disclosurePersonalData?.retentionPeriodEn ||
                                              '-'
                                    }`
                                )}
                            </div>
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'International transfer of personal data'
                                    : 'การส่งหรือโอนข้อมูลส่วนบุคคลของเจ้าของข้อมูลไปต่างประเทศมีอะไรบ้าง'}
                            </div>
                            <div className="py-2 whitespace-pre-wrap text-[#65707A]">
                                {parse(
                                    `${
                                        previewLang === 'TH'
                                            ? disclosurePersonalData?.transferPersonalDataTh ||
                                              '-'
                                            : disclosurePersonalData?.transferPersonalDataEn ||
                                              '-'
                                    }`
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <div
                        className="flex px-4 py-1 items-center mb-4"
                        style={{ background: '#F4F6FC' }}
                    >
                        <div className="flex-1 text-purple-PHX font-semibold">
                            {previewLang === 'EN'
                                ? 'The rights of data owners and safety'
                                : 'สิทธิเจ้าของข้อมูลและความปลอดภัย'}
                        </div>
                        <div
                            className="mt-1 hover:opacity-80 cursor-pointer"
                            onClick={() => {
                                props.goToStep(3);
                            }}
                        >
                            {EditIcon}
                        </div>
                    </div>
                    <div className="text-sm space-y-2">
                        <div className="font-semibold text-[#65707A]">
                            <div>
                                {previewLang === 'EN'
                                    ? 'Right to withdraw consent'
                                    : 'สิทธิขอเพิกถอนความยินยอม'}
                            </div>
                        </div>
                        <div className="pl-2 whitespace-pre-wrap text-[#65707A]">
                            {parse(
                                `${
                                    previewLang === 'TH'
                                        ? dataSubjectRightAndSecure?.rightToWithdrawConsentTh ||
                                          '-'
                                        : dataSubjectRightAndSecure?.rightToWithdrawConsentEn ||
                                          '-'
                                }`
                            )}
                        </div>
                        <div className="font-semibold text-[#65707A]">
                            <div>
                                {previewLang === 'EN'
                                    ? 'Right to access and obtain copy'
                                    : 'สิทธิขอเข้าถึงข้อมูลและขอรับสำเนา'}
                            </div>
                        </div>
                        <div className="pl-2 whitespace-pre-wrap text-[#65707A]">
                            {parse(
                                `${
                                    previewLang === 'TH'
                                        ? dataSubjectRightAndSecure?.rightOfAccessTh ||
                                          '-'
                                        : dataSubjectRightAndSecure?.rightOfAccessEn ||
                                          '-'
                                }`
                            )}
                        </div>
                        <div className="font-semibold text-[#65707A]">
                            <div>
                                {previewLang === 'EN'
                                    ? 'Right to data portability'
                                    : 'สิทธิขอถ่ายโอนข้อมูล'}
                            </div>
                        </div>
                        <div className="pl-2 whitespace-pre-wrap text-[#65707A]">
                            {parse(
                                `${
                                    previewLang === 'TH'
                                        ? dataSubjectRightAndSecure?.rightOfDataPortabilityTh ||
                                          '-'
                                        : dataSubjectRightAndSecure?.rightOfDataPortabilityEn ||
                                          '-'
                                }`
                            )}
                        </div>
                        <div className="font-semibold text-[#65707A]">
                            <div>
                                {previewLang === 'EN'
                                    ? 'Right to object'
                                    : 'สิทธิขอคัดค้าน'}
                            </div>
                        </div>
                        <div className="pl-2 whitespace-pre-wrap text-[#65707A]">
                            {parse(
                                `${
                                    previewLang === 'TH'
                                        ? dataSubjectRightAndSecure?.rightToObjectTh ||
                                          '-'
                                        : dataSubjectRightAndSecure?.rightToObjectEn ||
                                          '-'
                                }`
                            )}
                        </div>
                        <div className="font-semibold text-[#65707A]">
                            <div>
                                {previewLang === 'EN'
                                    ? 'Right to restrict'
                                    : 'สิทธิขอระงับการใช้ข้อมูล'}
                            </div>
                        </div>
                        <div className="pl-2 whitespace-pre-wrap text-[#65707A]">
                            {parse(
                                `${
                                    previewLang === 'TH'
                                        ? dataSubjectRightAndSecure?.rightToRestrictProcessingTh ||
                                          '-'
                                        : dataSubjectRightAndSecure?.rightToRestrictProcessingEn ||
                                          '-'
                                }`
                            )}
                        </div>
                        <div className="font-semibold text-[#65707A]">
                            <div>
                                {previewLang === 'EN'
                                    ? 'Right to erasure'
                                    : 'สิทธิขอให้ลบหรือทำลายข้อมูล'}
                            </div>
                        </div>
                        <div className="pl-2 whitespace-pre-wrap text-[#65707A]">
                            {parse(
                                `${
                                    previewLang === 'TH'
                                        ? dataSubjectRightAndSecure?.rightToErasureTh ||
                                          '-'
                                        : dataSubjectRightAndSecure?.rightToErasureEn ||
                                          '-'
                                }`
                            )}
                        </div>
                        <div className="font-semibold text-[#65707A]">
                            <div>
                                {previewLang === 'EN'
                                    ? 'Right to rectification'
                                    : 'สิทธิขอให้แก้ไขข้อมูล'}
                            </div>
                        </div>
                        <div className="pl-2 whitespace-pre-wrap text-[#65707A]">
                            {parse(
                                `${
                                    previewLang === 'TH'
                                        ? dataSubjectRightAndSecure?.rightToRectificationTh ||
                                          '-'
                                        : dataSubjectRightAndSecure?.rightToRectificationEn ||
                                          '-'
                                }`
                            )}
                        </div>
                        {dataSubjectRightAndSecure?.rightToComplaintTh && (
                            <>
                                <div className="font-semibold text-[#65707A]">
                                    <div>
                                        {previewLang === 'EN'
                                            ? 'Right to Complaint'
                                            : 'สิทธิขอร้องเรียนข้อมูล'}
                                    </div>
                                </div>
                                <div className="mb-4 pl-2 whitespace-pre-wrap text-[#65707A]">
                                    {parse(
                                        `${
                                            previewLang === 'TH'
                                                ? dataSubjectRightAndSecure?.rightToComplaintTh ||
                                                  '-'
                                                : dataSubjectRightAndSecure?.rightToComplaintEn ||
                                                  '-'
                                        }`
                                    )}
                                </div>
                            </>
                        )}
                        <Divider dashed className="border-t-2" />
                        <div className="font-semibold text-[#171717]">
                            {previewLang === 'EN'
                                ? 'How security measures and quality of data'
                                : 'มาตรการรักษาความมั่นคงปลอดภัยและคุณภาพของข้อมูลมีอะไรบ้าง'}
                        </div>
                        <div className="whitespace-pre-wrap text-[#65707A]">
                            {parse(
                                `${
                                    previewLang === 'TH'
                                        ? dataSubjectRightAndSecure?.securityMeasureTh ||
                                          '-'
                                        : dataSubjectRightAndSecure?.securityMeasureEn ||
                                          '-'
                                }`
                            )}
                        </div>
                    </div>
                </div>

                <div className="mt-2">
                    <div
                        className="flex px-4 py-1 items-center mb-4"
                        style={{ background: '#F4F6FC' }}
                    >
                        <div className="flex-1 text-purple-PHX font-semibold">
                            {previewLang === 'EN'
                                ? 'Marketing advertisement'
                                : 'การโฆษณาการตลาด'}
                        </div>
                        <div
                            className="mt-1 hover:opacity-80 cursor-pointer"
                            onClick={() => {
                                props.goToStep(4);
                            }}
                        >
                            {EditIcon}
                        </div>
                    </div>
                    <div className="text-sm space-y-2">
                        <div className="font-semibold text-[#171717]">
                            {previewLang === 'EN'
                                ? 'What are the marketing and promotional activities'
                                : 'กิจกรรมทางการตลาดและการส่งเสริมการตลาดมีอะไรบ้าง'}
                        </div>
                        <div className="whitespace-pre-wrap text-[#65707A]">
                            {parse(
                                `${
                                    previewLang === 'TH'
                                        ? marketingAdvertising?.marketingActivityTh ||
                                          '-'
                                        : marketingAdvertising?.marketingActivityEn ||
                                          '-'
                                }`
                            )}
                        </div>
                    </div>
                </div>

                <div className="mt-2">
                    <div
                        className="flex px-4 py-1 items-center mb-4"
                        style={{ background: '#F4F6FC' }}
                    >
                        <div className="flex-1 text-purple-PHX font-semibold">
                            {previewLang === 'EN'
                                ? 'Privacy policy'
                                : 'นโยบายที่เกี่ยวกับข้อมูลส่วนบุคคล'}
                        </div>
                        <div
                            className="mt-1 hover:opacity-80 cursor-pointer"
                            onClick={() => {
                                props.goToStep(5);
                            }}
                        >
                            {EditIcon}
                        </div>
                    </div>
                    <div className="text-sm space-y-2">
                        <div className="font-semibold text-[#171717]">
                            {previewLang === 'EN'
                                ? 'What are the privacy policies of other websites'
                                : 'นโยบายคุ้มครองข้อมูลส่วนบุคคลของเว็บไซต์อื่นมีอะไรบ้าง'}
                        </div>
                        <div className="py-2 whitespace-pre-wrap text-[#65707A]">
                            {parse(
                                `${
                                    previewLang === 'TH'
                                        ? privacyPolicy?.policyWebsiteTh || '-'
                                        : privacyPolicy?.policyWebsiteEn || '-'
                                }`
                            )}
                        </div>
                        <Divider dashed className="border-t-2" />
                        <div className="font-semibold text-[#171717]">
                            {previewLang === 'EN'
                                ? 'In case you refuse to disclose Or use personal information'
                                : 'ในกรณีที่ท่านปฏิเสธไม่เปิดเผย หรือให้ใช้ข้อมูลส่วนบุคคลมีอะไรบ้าง'}
                        </div>
                        <div className="py-2 whitespace-pre-wrap text-[#65707A]">
                            {parse(
                                `${
                                    previewLang === 'TH'
                                        ? privacyPolicy?.undisclosedReasonTh ||
                                          '-'
                                        : privacyPolicy?.undisclosedReasonEn ||
                                          '-'
                                }`
                            )}
                        </div>
                        <Divider dashed className="border-t-2" />
                        <div className="font-semibold text-[#171717]">
                            {previewLang === 'EN'
                                ? 'What are the actions, practices and policies regarding personal data'
                                : 'การดำเนินการ แนวปฏิบัติ และนโยบายที่เกี่ยวกับข้อมูลส่วนบุคคลมีอะไรบ้าง'}
                        </div>
                        <div className="py-2 whitespace-pre-wrap text-[#65707A]">
                            {parse(
                                `${
                                    previewLang === 'TH'
                                        ? privacyPolicy?.processPolicyTh || '-'
                                        : privacyPolicy?.processPolicyEn || '-'
                                }`
                            )}
                        </div>
                    </div>
                </div>

                <div className="mt-2">
                    <div
                        className="flex px-4 py-1 items-center mb-4"
                        style={{ background: '#F4F6FC' }}
                    >
                        <div className="flex-1 text-purple-PHX font-semibold">
                            {previewLang === 'EN'
                                ? 'Personal Data Protection Officer'
                                : 'เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล (DPO)'}
                        </div>
                        <div
                            className="mt-1 hover:opacity-80 cursor-pointer"
                            onClick={() => {
                                props.goToStep(6);
                            }}
                        >
                            {EditIcon}
                        </div>
                    </div>
                    <div className="text-sm space-y-2">
                        <div className="font-semibold text-[#171717]">
                            {previewLang === 'EN'
                                ? 'Data Protection Officer'
                                : 'เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล'}
                        </div>
                        <div className="whitespace-pre-wrap text-[#65707A]">
                            {parse(
                                `${
                                    previewLang === 'TH'
                                        ? dpo?.dpoNameTh || '-'
                                        : dpo?.dpoNameEn || '-'
                                }`
                            )}
                        </div>
                    </div>
                </div>

                <div className="mt-2">
                    <div
                        className="flex px-4 py-1 items-center mb-4"
                        style={{ background: '#F4F6FC' }}
                    >
                        <div className="flex-1 text-purple-PHX font-semibold">
                            {previewLang === 'EN'
                                ? 'Personal Data Controller'
                                : 'ผู้ควบคุมข้อมูลส่วนบุคคล (Data Controller)'}
                        </div>
                        <div
                            className="mt-1 hover:opacity-80 cursor-pointer"
                            onClick={() => {
                                props.goToStep(7);
                            }}
                        >
                            {EditIcon}
                        </div>
                    </div>
                    <div className="text-sm space-y-2">
                        <div className="font-semibold text-[#171717]">
                            {previewLang === 'EN'
                                ? 'Contact channel'
                                : 'ช่องทางการติดต่อบริษัท'}
                        </div>
                        <div className="whitespace-pre-wrap text-[#65707A]">
                            {parse(
                                `${
                                    previewLang === 'TH'
                                        ? dataController?.contactChannelTh ||
                                          '-'
                                        : dataController?.contactChannelEn ||
                                          '-'
                                }`
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <ModalConfirm
                open={openConfirm}
                handelClose={() => setOpenConfirm(false)}
                loading={props.loading_}
                handelOk={() => {
                    if (ref.current) ref.current.click();
                }}
                title={
                    <div className="flex-column items-center text-center space-y-2">
                        <div className="font-normal text-1xl">
                            {t('Publish this policy')}
                        </div>
                        <Tag
                            className="rounded-xl text-center bg-[#7B67FB]"
                            style={{ color: '#FFFFFF', borderColor: '#FFFFFF' }}
                        >
                            {t('Consent.PublishedVersion')}:{' '}
                            {isPublishedVersion ? getNextVersion() : '0001.0'}
                        </Tag>
                        <div className="font-normal text-[13px] text-[#65707A]">
                            {t('Consent.ModalDesPublish')}
                        </div>
                    </div>
                }
                text=""
            />
        </Form>
    );
};

export default StepPreview;

const EditIcon = (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M18.988 2.01172L21.988 5.01172L19.701 7.29972L16.701 4.29972L18.988 2.01172ZM8 15.9997H11L18.287 8.71272L15.287 5.71272L8 12.9997V15.9997Z"
            fill="#7B67FB"
        />
        <path
            d="M19 19H8.158C8.132 19 8.105 19.01 8.079 19.01C8.046 19.01 8.013 19.001 7.979 19H5V5H11.847L13.847 3H5C3.897 3 3 3.896 3 5V19C3 20.104 3.897 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V10.332L19 12.332V19Z"
            fill="#7B67FB"
        />
    </svg>
);

const Dot = (
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="50" />
    </svg>
);

export const svgNoImage = (
    <svg
        width={40}
        height={40}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx={20} cy={20} r={20} fill="#EDEEF9" />
        <g opacity="0.5">
            <path
                d="M27 11H13C11.8954 11 11 11.8954 11 13V27C11 28.1046 11.8954 29 13 29H27C28.1046 29 29 28.1046 29 27V13C29 11.8954 28.1046 11 27 11Z"
                stroke="#A9B2FF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.5 18C17.3284 18 18 17.3284 18 16.5C18 15.6716 17.3284 15 16.5 15C15.6716 15 15 15.6716 15 16.5C15 17.3284 15.6716 18 16.5 18Z"
                stroke="#A9B2FF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M29 23L24 18L13 29"
                stroke="#A9B2FF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </svg>
);
